import type { User } from 'types/User';

export interface UrlTemplates {
  click_ref_template?: string;
  url: string;
  url_template?: string;
}

type ClickRefInputs = {
  buttonPosition?: number;
  clickRef?: string;
  user: User;
};

export function getTrackedUrlAndClickRef(
  templates: UrlTemplates,
  inputs: ClickRefInputs
) {
  if (!templates.url_template || !templates.click_ref_template) {
    return {
      clickRef: '',
      url: templates.url
    };
  }

  const clickRef =
    inputs.clickRef ??
    templates.click_ref_template
      .replace('{userId}', inputs.user.id)
      .replace('{loggedInStatus}', inputs.user.isLoggedIn ? '1' : '0')
      .replace('{buttonPosition}', `${inputs.buttonPosition ?? -1}`);

  const url = templates.url_template.replace('{clickref}', clickRef);

  return {
    clickRef,
    url
  };
}
